const emailInput = document.querySelector('input.newsletter-signup__email');
const footerEmailInput = document.querySelector('input.footer-newsletter__email');
const footerCheckboxContainer = document.querySelector('div:has(> input.footer-newsletter__checkbox)');
const checkboxInput = document.querySelector('input.newsletter-signup__checkbox');
const footerCheckboxInput = document.querySelector('input.footer-newsletter__checkbox');
const submitButton = document.querySelector('.newsletter-signup__submit');
const footerSubmitButton = document.querySelector('.footer-newsletter__submit');
const errorField = document.querySelector('.newsletter-signup__error');
const footerErrorField = document.querySelector('.footer-newsletter__error');
const closeButton = document.querySelector('.signup-drawer-close');
const submitButtonText = document.querySelector('.newsletter-signup__submit span');
const footerSubmitButtonText = document.querySelector('.footer-newsletter__submit span');
const loadingSpinner = document.querySelector('.newsletter-signup__submit .loading__spinner');
const footerLoadingSpinner = document.querySelector('.footer-newsletter__submit .loading__spinner');

emailInput?.addEventListener('input', () => {
  emailInputHandler(emailInput, errorField, submitButton, null, checkboxInput);
});

footerEmailInput?.addEventListener('input', () => {
  emailInputHandler(
    footerEmailInput,
    footerErrorField,
    footerSubmitButton,
    footerCheckboxContainer,
    footerCheckboxInput
  );
});

checkboxInput?.addEventListener('change', () => {
  enableSubmitButton(checkboxInput, submitButton);
});

footerCheckboxInput?.addEventListener('change', () => {
  enableSubmitButton(footerCheckboxInput, footerSubmitButton);
});

submitButton?.addEventListener('click', () => {
  if (isValidEmail(emailInput.value, errorField)) {
    subscribeToNewsletter(emailInput, errorField, submitButton, submitButtonText, loadingSpinner);
  }
});

footerSubmitButton?.addEventListener('click', () => {
  if (isValidEmail(footerEmailInput.value, footerErrorField)) {
    subscribeToNewsletter(
      footerEmailInput,
      footerErrorField,
      footerSubmitButton,
      footerSubmitButtonText,
      footerLoadingSpinner
    );
  }
});

closeButton?.addEventListener('click', () => {
  emailInput.value = '';
  errorField.textContent = '';
  errorField.classList.remove('error');
  errorField.classList.remove('success');
});

function emailInputHandler(emailInput, errorField, submitButton, checkboxContainer, checkboxInput) {
  errorField.textContent = '';
  errorField.classList.remove('error');
  if (emailInput.value === '') {
    checkboxContainer?.classList.remove('tw-flex');
    checkboxContainer?.classList.add('tw-hidden');
    checkboxInput.checked = false;
    submitButton.setAttribute('disabled', true);
  } else {
    checkboxContainer?.classList.remove('tw-hidden');
    checkboxContainer?.classList.add('tw-flex');
  }
}

function isValidEmail(email, errorField) {
  const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

  if (!email.match(emailRegex)) {
    errorField.classList.add('error');
    errorField.textContent = window.accessibilityStrings.emailError;
    return false;
  }

  errorField.classList.remove('error');
  errorField.textContent = '';
  return true;
}

function enableSubmitButton(checkboxInput, submitButton) {
  if (checkboxInput.checked) {
    submitButton.removeAttribute('disabled');
  } else {
    submitButton.setAttribute('disabled', true);
  }
}

function subscribeToNewsletter(emailInput, errorField, submitButton, submitButtonText, loadingSpinner) {
  const listId =
    document.querySelector('.newsletter-signup__wrapper').dataset.listId ??
    document.querySelector('.footer-newsletter').dataset.listId;
  const url = 'https://a.klaviyo.com/client/subscriptions?company_id=ShbyPU';
  const options = {
    method: 'POST',
    headers: {
      accept: 'application/vnd.api+json',
      revision: '2025-01-15',
      'content-type': 'application/vnd.api+json',
    },
    body: JSON.stringify({
      data: {
        type: 'subscription',
        attributes: {
          profile: {
            data: {
              type: 'profile',
              attributes: {
                subscriptions: {
                  email: {
                    marketing: {
                      consent: 'SUBSCRIBED',
                    },
                  },
                  sms: {
                    marketing: {
                      consent: 'SUBSCRIBED',
                    },
                    transactional: {
                      consent: 'SUBSCRIBED',
                    },
                  },
                },
                email: emailInput.value,
              },
            },
          },
        },
        relationships: {
          list: {
            data: {
              type: 'list',
              id: listId,
            },
          },
        },
      },
    }),
  };

  submitButton.setAttribute('disabled', true);
  submitButtonText.classList.add('hidden');
  loadingSpinner.classList.remove('hidden');
  fetch(url, options)
    .then((res) => {
      if (res.ok) {
        errorField.classList.remove('error');
        errorField.classList.add('success');
        errorField.textContent = window.accessibilityStrings.signupSuccess;
      } else {
        errorField.classList.remove('success');
        errorField.classList.add('error');
        errorField.textContent = window.accessibilityStrings.signupError;
      }
    })
    .finally(() => {
      submitButton.removeAttribute('disabled');
      submitButtonText.classList.remove('hidden');
      loadingSpinner.classList.add('hidden');
    })
    .catch((err) => console.error(err));
}
